export default __webpack_public_path__ + "assets/images/0c09fd2ecc9712c43958325b37a18956.png";